import { keys, reduce, isNil } from 'lodash';
import { DeclarationForm } from '@models/MLTC/Declaration.model'
import { IError } from '@utils/useForm';

export const validate = (values: DeclarationForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'summary':
    case 'term':
    case 'declaration':
    case 'required1':
    case 'required2':
    case 'required3':
    case 'understand':
      if (isNil(value) || value === false) {
        error = {isValid: false};
      }
      break;
  }
  return error;
}